import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Select, Input, Textarea, Checkbox } from 'components/fields'
import { MaterialModal } from 'components/layout'
import { InfoBubble, Note, Title } from 'components/misc'
import { InfoAssessorModal } from 'components/modals'
import { form, modal } from 'helpers/decorators'
import { apiAssessors, apiCodeLists, apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import { initialValuesEditActivity } from 'models/activities'
import validate from './edit-activity.validation'
import { CONFIGURATION_KEYS, LEVELS } from 'constants/enums'
import { connect } from 'react-redux'
import MODALS from 'constants/layout/modals'
import styles from './edit-activity.styl'
import assessorsDropdownSelector from '../../../../redux/selectors/assessors/assessorsDropdownSelector'
import DownloadButton from '../../../misc/DownloadButton/DownloadButton'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'

@injectIntl
@apiAssessors()
@apiConfiguration()
@apiDashboard.apiActivity({
  loaders: ['edit']
})
@apiCodeLists(['titles'], {
  public: true
})
@connect(({ api, auth }) => ({
  user: auth.user,
  assessor: api.assessor
}))
@form({
  form: 'editActivity',
  disableHook: true,
  validate
})
@modal.trigger()
class EditActivity extends Component {
  static propTypes = {
    onGetActivityCategories: PropTypes.func.isRequired,
    onGetConfigurationValues: PropTypes.func.isRequired,
    onEditActivity: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    nestedModal: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    activityId: PropTypes.number,
    editStatus: PropTypes.object,
    codeLists: PropTypes.object,
    colorClass: PropTypes.string,
    user: PropTypes.object,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func.isRequired,
    activity: PropTypes.object,
    assessor: PropTypes.object,
    awardLevel: PropTypes.object,
    intl: PropTypes.object
  }

  componentWillMount = async () => {
    await Promise.all([
      this.props.onGetActivityCategories(),
      this.props.onGetConfigurationValues(
        [
          CONFIGURATION_KEYS.assessorMandatory.id,
          CONFIGURATION_KEYS.assessorWelcomeEmail.id,
          CONFIGURATION_KEYS.isSimplifiedAssessmentAllowed.id
        ],
        this.getOrgId(),
        true
      )
    ])
    this.props.initialize(initialValuesEditActivity(this.props.activity))

    const orgId = this.getOrgId()

    const activityCategoryId = this.getSubcategoryValue()

    if (orgId && activityCategoryId && activityCategoryId !== 'others') {
      this.props.onGetAvailableAssessorsForActivityCategory(orgId, activityCategoryId)
    }
  }

  getOrgId() {
    return get(this.props, 'activity.award.organization.id')
  }
  getSubcategoryValue() {
    return get(this.props.activity, 'activityCategory.id')
  }

  handleSubmit = fields =>
    this.props.onEditActivity(this.props.activityId, fields, {
      resetForm: this.props.reset,
      activity: this.props.activity
    })

  clearForm = () => {
    this.props.initialize({
      ...this.props.values,
      assessorEmail: null,
      assessorPhone: null,
      assessorName: null,
      assessorTitle: null,
      assessorRelevantExperience: null
    })
  }

  handleOpenAssessor = () => this.props.nestedModal(MODALS.INFO_ASSESSOR)

  render() {
    const { codeLists, colorClass, editStatus, handleSubmit, activityId, values, activity, assessor, awardLevel } = this.props

    const isBronze = (get(awardLevel, 'value') === LEVELS.BRONZE.id)
    const isSimplifiedAssessmentAllowed = get(this.props,
      `configuration.values.${CONFIGURATION_KEYS.isSimplifiedAssessmentAllowed.id}.booleanValue`)
    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(activity)
    const assessorWelcomeEmail = get(this.props,
      `configuration.values.${CONFIGURATION_KEYS.assessorWelcomeEmail.id}.booleanValue`)
    const subcategoryValue = get(activity, 'activityCategory.name')
    const isOthersSubCategory = subcategoryValue === 'others'
    const dropdownAssessors = assessorsDropdownSelector(assessor, isOthersSubCategory, this.props)
    const needHelpFromAwardLeader = get(values, 'setupAssessorId') === -1
    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0
    const isAwardLeaderAssessor = get(values, 'isAwardLeaderAssessor')

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.activity_details"
            defaultMessage="Activity Details"
          />
        </Title>

        <div className="row">
          <div className="col-xs-12">
            <Textarea
              rows={3}
              resizeable
              name="aim"
              label="Goal"
              intlKey="label.goal"
            />
          </div>
        </div>

        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.assessor_details"
            defaultMessage="Assessor Details"
          />

          <span style={{ marginLeft: '10px' }}>
            <InfoBubble onClick={this.handleOpenAssessor} />
          </span>
        </Title>

        {assessorWelcomeEmail && !isAssessorManagementEnabled &&
        <div className={styles.assessorInfoDownload}>
          <DownloadButton
            url={`/documents?entity=activity&entityId=${activityId}&output=pdf&configName=WELCOME_EMAIL_A`}
            apiParams
            secondary
            link
          >
            <FormattedMessage
              id="button.download_info_for_assessor"
              defaultMessage="Download info for assessor"
            />
          </DownloadButton>
        </div>
        }

        {isSimplifiedAssessmentAllowed && isBronze && <div className="row">
          <div className="col-xs-12">
            <Checkbox
              name="isAwardLeaderAssessor"
              label="Same as Award Leader"
              intlKey="label.same_as_award_leader"
            />
          </div>
        </div>
        }

        {isAssessorManagementEnabled && <div>
          {!isOthersSubCategory && !needHelpFromAwardLeader && <div className={styles.selectAssessor}><FormattedMessage
            id="label.select_award_unit_assessor"
            defaultMessage="Select from assessors already approved by your Award Unit or create a new one below."
          /></div>}


          {isOthersSubCategory && <div className={styles.assessorIsDisabled}><FormattedMessage
            id="label.assessor_disabled_for_other_activity"
            defaultMessage="Assessor selection is disabled for other activity."
          /></div>}

          {<div className="row">
            <div className="col-xs-12">
              <Select
                name="setupAssessorId"
                label=""
                intlKey=""
                options={dropdownAssessors}
                disabled={!subcategoryValue}
                onChange={() => this.clearForm()}
              />
            </div>
          </div>}
        </div>}

        {(!isAssessorManagementEnabled || isNoneOfTheseSubCategory) &&
        !isOthersSubCategory && !needHelpFromAwardLeader && !isAwardLeaderAssessor && <div>
          <div className="row">
            <div className="col-xs-12">
              <Select
                name="assessorTitle"
                label="Title"
                intlKey="label.title"
                options={get(codeLists, 'titles.list')}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Input name="assessorName" label="Name" intlKey="label.name" maxLength={100} />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Input
                name="assessorEmail"
                label="Email"
                type="email"
                intlKey="label.email"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Input
                name="assessorPhone"
                label="Phone"
                intlKey="label.phone"
              />
            </div>
          </div>

          {isNoneOfTheseSubCategory && <div className="row">
            <div className="col-xs-12">
              <Note >
                <FormattedMessage
                  id="label.assessor_relevant_exp_desc"
                  defaultMessage="To help your Award Leader decide if this person is a viable Assessor, please provide some information about their experience in this activity e.g. coach."
                />
              </Note>
              <Input
                name="assessorRelevantExperience"
                label="Relevant Experience"
                intlKey="label.relevant_experience"
              />
            </div>
          </div>}
        </div>}

        <InfoAssessorModal />

        <MaterialModal.Footer
          action="Save"
          actionKey="button.save"
          colorClass={colorClass}
          insideContent
          isLoading={get(editStatus, 'loading')}
        />
      </form>
    )
  }
}

export default EditActivity
